// extracted by mini-css-extract-plugin
export default {"control":"Control_control__KUaBb","button":"Control_button__RUM2k"};